import React from 'react'

const CallToActionBar = ({ brand }) => {
	switch (brand) {
		case 'lexus':
			return (
				<>
					<div className="block-section call-to-action-bar container clearfix">
						<h2 className="mb-4 text-center">Staat uw antwoord er niet bij?</h2>
						<p className="text-center">Wij helpen u graag en staan voor u klaar op maandag t/m vrijdag van 09:00u tot 17:00u.</p>

						<div className="call-to-action-bar__grid">
							<article>
								<img src="/asset/image/contact/icon-chat.webp" alt="Live chat" loading="lazy" />
								<h3>Live chat</h3>
								<p className="text-center">U vindt live chat rechtsonder op iedere pagina.<br/> Gemiddelde wachttijd 30 seconden</p>
							</article>

							<article>
								<img src="/asset/image/contact/icon-telefoon.webp" alt="Telefoon - Algemeen" loading="lazy" />
								<h3>Telefoon - Algemeen</h3>
								<p className="text-center">Bel gratis <a href="tel:08000315" target="_blank" rel="noopener noreferrer">0800 - 0315</a><br/> Gemiddelde wachttijd minder dan 30 seconden</p>
							</article>

							<article>
								<img src="/asset/image/contact/icon-telefoon.webp" alt="Telefoon - Private lease" loading="lazy" />
								<h3>Telefoon - Private lease</h3>
								<p className="text-center">Bel <a href="tel:0347367940" target="_blank" rel="noopener noreferrer">0347 – 367 940</a> <br/> voor vragen over Private lease</p>
							</article>

							<article>
								<img src="/asset/image/contact/icon-whatsapp.webp" alt="Whatsapp" loading="lazy" />
								<h3>Whatsapp</h3>
								<p className="text-center">Voeg <a href="https://api.whatsapp.com/send?phone=31162585711">0162-585711</a> toe aan uw contactpersonen. <br/>Wij antwoorden binnen 4 uur.</p>
							</article>

							<article>
								<img src="/asset/image/contact/icon-form.webp" alt="Contactformulier" loading="lazy" />
								<h3>Contactformulier</h3>
								<p className="text-center">Stel uw vraag via het <a href="https://www.lexus.nl/contact/klantenservice/#/iframe/https%3A%2F%2Fformulieren.lexus.nl%2Fcontact.html" target="_parent">contactformulier</a>
								<br/> Antwoord binnen 5 werkdagen.</p>
							</article>

							<article>
								<img src="/asset/image/contact/icon-onderhoud-reparatie.webp" alt="Pechhulp" loading="lazy" />
								<h3>Pechhulp</h3>
								<p className="text-center">24 uur per dag, 7 dagen per week <br/>
								Nederland (gratis) <a href="tel:08002200024">0800 - 2200024</a> <br/>
								Buitenland <a href="tel:0031205929838">+31 - 205929838</a></p>
							</article>
						</div>
					</div>
				</>
			)
		default:
			return (
				<div className="block-section call-to-action-bar container clearfix">
					<h2 className="mb-4">Staat uw antwoord er niet bij?</h2>
					<p className="text-center">Wij helpen u graag en staan voor u klaar op maandag t/m vrijdag van 09:00u tot 17:00u.</p>

					<div className="call-to-action-bar__grid">
						<article>
							<img src="/asset/image/contact/icon-chat.webp" alt="Live chat" loading="lazy" />
							<h3>Live chat</h3>
							<p className="text-center">U vindt live chat rechtsonder op iedere pagina.<br/> Gemiddelde wachttijd 30 seconden</p>
						</article>

						<article>
							<img src="/asset/image/contact/icon-telefoon.webp" alt="Telefoon - Algemeen" loading="lazy" />
							<h3>Telefoon - Algemeen</h3>
							<p className="text-center">Bel gratis <a href="tel:08000369" target="_blank" rel="noopener noreferrer">0800 - 0369</a><br/> Gemiddelde wachttijd minder dan 30 seconden</p>
						</article>

						<article>
							<img src="/asset/image/contact/icon-telefoon.webp" alt="Telefoon - Private lease" loading="lazy" />
							<h3>Telefoon - Private lease</h3>
							<p className="text-center">Bel <a href="tel:0347367950" target="_blank" rel="noopener noreferrer">0347 - 367950</a> <br/> voor vragen over Private lease</p>
						</article>

						<article>
							<img src="/asset/image/contact/icon-whatsapp.webp" alt="Whatsapp" loading="lazy" />
							<h3>Whatsapp</h3>
							<p className="text-center">Voeg <a href="https://api.whatsapp.com/send?phone=08000369">0800-0369</a> toe aan uw contactpersonen. <br/> Wij antwoorden binnen 4 uur.</p>
						</article>

						<article>
							<img src="/asset/image/contact/icon-form.webp" alt="Contactformulier" loading="lazy" />
							<h3>Contactformulier</h3>
							<p className="text-center">Stel uw vraag via het <a href="https://www.toyota.nl/over-toyota/klantenservice/#/iframe/https%3A%2F%2Fformulieren.toyota.nl%2Fcontact.html" target="_parent">contactformulier</a> <span className="icon icon-external"></span>
							<br/> Antwoord binnen 5 werkdagen.</p>
						</article>

						<article>
							<img src="/asset/image/contact/icon-onderhoud-reparatie.webp" alt="Pechhulp" loading="lazy" />
							<h3>Pechhulp</h3>
							<p className="text-center">24 uur per dag, 7 dagen per week <br/>
							Nederland (gratis) <a href="tel:08002200025">0800 - 2200025</a> <br/>
							Buitenland <a href="tel:0031205929836"> +31 - 205929836</a></p>
						</article>
					</div>
				</div>
			)
	}
}

export default CallToActionBar
